import apiService from "./apiService";

const acctMasterService = {
    async searchRPU(searchModel) {
        try {
            return (await apiService.post(`acctmaster/search-rpu`, searchModel, true)).data;
        }
        catch {
            return [];
        }
    },
    
};

export default acctMasterService;